import type { ProvisionResult } from "@/features/admin";
import { useState } from "react";
import { AdminPageLayout } from "../layout";
import { CredentialsCard } from "./components/credentials-card";
import { ProvisionForm } from "./components/provision-form";
import { StaffAccess } from "./components/staff-access";
import { TenantUsers } from "./components/tenant-users";

/**
 * SYSADMIN provisioning screen — create a tenant + its first user with a chosen email and
 * password, so the credentials can be sent straight to the client instead of going through
 * the self-service signup (email OTP + invitation).
 */
export function AdminProvisioningPage() {
  const [result, setResult] = useState<ProvisionResult | null>(null);
  const [tenantId, setTenantId] = useState("");

  return (
    <AdminPageLayout
      title="Accès clients"
      description="Créer un tenant et son utilisateur avec des identifiants choisis"
    >
      <div className="grid gap-6 lg:grid-cols-2">
        <ProvisionForm onCreated={setResult} onTenantChange={setTenantId} />
        <div className="space-y-6">
          {result ? <CredentialsCard result={result} /> : null}
          <TenantUsers tenantId={tenantId} />
          <StaffAccess />
        </div>
      </div>
    </AdminPageLayout>
  );
}
